import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ctgklsnnmx: FaireBrandEntity = {
  token: "b_ctgklsnnmx",
  type: "brand",
  name: "KkCo",
  avatarUrl:
    "https://cdn.faire.com/fastly/f681767bc64a6cb62c824d068427f33551cdd0aaf66019b7a491697c0b0a03bb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b62ad7833622754b838d8b99154655ecca40c5d3a53a3bc982590476b11565ec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f681767bc64a6cb62c824d068427f33551cdd0aaf66019b7a491697c0b0a03bb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b62ad7833622754b838d8b99154655ecca40c5d3a53a3bc982590476b11565ec.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "KkCo is an exploration of juxtaposition and unexpected details. Artfully weaving between masculine and feminine, sport and special occasion, function and form, KkCo occupies the space between. Reveling in the fluid complexities of style, each individual piece is designed with versatility in mind. Utilizing sport and functional fabrications and applying them in unexpected silhouettes, we've become known for bringing outdoor-wear inside.\n\nWe put a lot of emphasis on the quality of our design and product. We approach our production process consciously. With a focus on working with family owned and operated factories that follow sustainable and ethical manufacturing practices. We work to minimize our waste and recycle our production scraps by reinventing them into something new.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:46.613Z",
    importedBy: "entity-db-cli",
  },
};
